import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
var _excluded = ["pageType"],
  _excluded2 = ["inventory", "filterValues", "consumerMetadata"],
  _excluded3 = ["owner", "inventory", "filterValues", "par", "pixallData", "hasListingType", "pageType", "consumerMetadata"],
  _excluded4 = ["filterValues", "listingType", "clickType", "hasListingType", "consumerMetadata"];
import _regeneratorRuntime from "@babel/runtime/regenerator";
import hasDom from 'has-dom';
import deepmerge from 'deepmerge';
import _get from 'lodash/get';
import { DataLayerTransformer, inventoryTransformer, QueryStringTransformer, ownerTransformer, listingTypeUtils } from '../../transformers/pixall';
import { cleanValues } from '../../utilities';
import ensurePixallPageLoad from './ensurePixallPageLoad';

// we don't want to fire meta-data event when we navigate between pages in SPA
// it should re-initialize Pixall instead
var isInitial = true;
export function transformData(_x) {
  return _transformData.apply(this, arguments);
}
function _transformData() {
  _transformData = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(_ref) {
    var filterValues, inventory, owner, pageType, _ref$consumerMetadata, consumerMetadata, dataLayer;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          filterValues = _ref.filterValues, inventory = _ref.inventory, owner = _ref.owner, pageType = _ref.pageType, _ref$consumerMetadata = _ref.consumerMetadata, consumerMetadata = _ref$consumerMetadata === void 0 ? {} : _ref$consumerMetadata, dataLayer = _ref.dataLayer;
          _context4.t0 = cleanValues;
          _context4.t1 = _extends;
          _context4.t2 = {};
          _context4.t3 = inventoryTransformer.getInventoryData(inventory, pageType);
          _context4.t4 = QueryStringTransformer.getSearchFacetVariables(filterValues);
          _context4.t5 = ownerTransformer.getOwnerData(owner);
          _context4.t6 = deepmerge;
          _context4.t7 = _extends;
          _context4.t8 = {};
          _context4.next = 12;
          return DataLayerTransformer.getConsumerMetadata(dataLayer);
        case 12:
          _context4.t9 = _context4.sent;
          _context4.t10 = (0, _context4.t7)(_context4.t8, _context4.t9);
          _context4.t11 = {
            consumerMetadata: consumerMetadata
          };
          _context4.t12 = (0, _context4.t6)(_context4.t10, _context4.t11);
          _context4.t13 = (0, _context4.t1)(_context4.t2, _context4.t3, _context4.t4, _context4.t5, _context4.t12);
          return _context4.abrupt("return", (0, _context4.t0)(_context4.t13));
        case 18:
        case "end":
          return _context4.stop();
      }
    }, _callee4);
  }));
  return _transformData.apply(this, arguments);
}
export var sendPageEvent = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_temp, _ref2, option) {
    var _ref4, pageType, data, dataLayer, history, eventPaths, pageParams, inventory, filterValues, _data$consumerMetadat, consumerMetadata, rest, params;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _ref4 = _temp === void 0 ? {} : _temp, pageType = _ref4.pageType, data = _objectWithoutPropertiesLoose(_ref4, _excluded);
          dataLayer = _ref2.dataLayer, history = _ref2.history;
          if (option === void 0) {
            option = {};
          }
          if (!hasDom()) {
            _context.next = 23;
            break;
          }
          if (pageType) {
            _context.next = 6;
            break;
          }
          throw new Error('Pixall: pageType is missing');
        case 6:
          // option.initialConfig is set up in useAnalytics
          eventPaths = _get(option, ['initialConfig', 'pixall', 'eventPaths'], {});
          pageParams = _get(option, ['initialConfig', 'pixall', 'page'], {});
          inventory = data.inventory, filterValues = data.filterValues, _data$consumerMetadat = data.consumerMetadata, consumerMetadata = _data$consumerMetadat === void 0 ? {} : _data$consumerMetadat, rest = _objectWithoutPropertiesLoose(data, _excluded2);
          _context.t0 = _extends;
          _context.t1 = {
            pageType: pageType
          };
          _context.t2 = DataLayerTransformer.getPageAttributes(dataLayer);
          _context.next = 14;
          return transformData({
            inventory: inventory,
            filterValues: filterValues,
            pageType: pageType,
            consumerMetadata: consumerMetadata,
            dataLayer: dataLayer
          });
        case 14:
          _context.t3 = _context.sent;
          _context.t4 = eventPaths;
          _context.t5 = pageParams;
          _context.t6 = rest;
          _context.t7 = {
            listingType: inventory && inventory.priority
          };
          params = (0, _context.t0)(_context.t1, _context.t2, _context.t3, _context.t4, _context.t5, _context.t6, _context.t7);
          if (!isInitial) {
            params.type = 'event';
            params.eventType = 'ajaxPageView';
          } else {
            // send meta-data on pageload so that pixall can handle plage event for us
            params.type = 'meta-data';
            isInitial = false;
          }
          _context.next = 23;
          return ensurePixallPageLoad(option, params, {
            history: history,
            isPageEvent: true
          });
        case 23:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function sendPageEvent(_x2, _x3, _x4) {
    return _ref3.apply(this, arguments);
  };
}();
export var sendClickEvent = /*#__PURE__*/function () {
  var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(data, dataLayer, option) {
    var owner, inventory, filterValues, par, _data$pixallData, pixallData, _data$hasListingType, hasListingType, pageType, _data$consumerMetadat2, consumerMetadata, rest, pageId, listingType, clickType, params;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          if (option === void 0) {
            option = {};
          }
          if (!hasDom()) {
            _context2.next = 16;
            break;
          }
          owner = data.owner, inventory = data.inventory, filterValues = data.filterValues, par = data.par, _data$pixallData = data.pixallData, pixallData = _data$pixallData === void 0 ? {} : _data$pixallData, _data$hasListingType = data.hasListingType, hasListingType = _data$hasListingType === void 0 ? true : _data$hasListingType, pageType = data.pageType, _data$consumerMetadat2 = data.consumerMetadata, consumerMetadata = _data$consumerMetadat2 === void 0 ? {} : _data$consumerMetadat2, rest = _objectWithoutPropertiesLoose(data, _excluded3);
          pageId = DataLayerTransformer.getPageId(dataLayer);
          listingType = pixallData.listingType || data.listingType || listingTypeUtils.getListingType(pageId, par);
          if (pixallData != null && pixallData.clickTypeToListingType) {
            // clickType will be inventory?.clickType or pixallData.clickType;
            clickType = (inventory == null ? void 0 : inventory.clickType) || pixallData.clickType;
            listingType = listingTypeUtils.convertClickTypeToListingType(clickType);
          }
          _context2.t0 = _extends;
          _context2.t1 = {
            type: 'event',
            eventType: 'click',
            pageId: pageId
          };
          _context2.next = 10;
          return transformData({
            filterValues: filterValues,
            inventory: inventory,
            owner: owner,
            pageType: pageType,
            consumerMetadata: consumerMetadata,
            dataLayer: dataLayer
          });
        case 10:
          _context2.t2 = _context2.sent;
          _context2.t3 = rest;
          params = (0, _context2.t0)(_context2.t1, _context2.t2, _context2.t3);
          if (hasListingType) {
            params.listingType = listingType;
          }
          _context2.next = 16;
          return ensurePixallPageLoad(option, params);
        case 16:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return function sendClickEvent(_x5, _x6, _x7) {
    return _ref5.apply(this, arguments);
  };
}();
export var sendImpression = /*#__PURE__*/function () {
  var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(_ref6, data, option) {
    var dataLayer, history, pageParams, filterValues, listingType, clickType, _data$hasListingType2, hasListingType, _data$consumerMetadat3, consumerMetadata, rest, params;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          dataLayer = _ref6.dataLayer, history = _ref6.history;
          if (option === void 0) {
            option = {};
          }
          pageParams = DataLayerTransformer.getPageAttributes(dataLayer);
          if (!hasDom()) {
            _context3.next = 16;
            break;
          }
          filterValues = data.filterValues, listingType = data.listingType, clickType = data.clickType, _data$hasListingType2 = data.hasListingType, hasListingType = _data$hasListingType2 === void 0 ? true : _data$hasListingType2, _data$consumerMetadat3 = data.consumerMetadata, consumerMetadata = _data$consumerMetadat3 === void 0 ? {} : _data$consumerMetadat3, rest = _objectWithoutPropertiesLoose(data, _excluded4);
          _context3.t0 = _extends;
          _context3.t1 = {
            type: 'event',
            eventType: 'impression'
          };
          _context3.t2 = pageParams;
          _context3.next = 10;
          return transformData({
            filterValues: filterValues,
            consumerMetadata: consumerMetadata,
            dataLayer: dataLayer
          });
        case 10:
          _context3.t3 = _context3.sent;
          _context3.t4 = rest;
          params = (0, _context3.t0)(_context3.t1, _context3.t2, _context3.t3, _context3.t4);
          if (hasListingType) {
            params.listingType = listingType || listingTypeUtils.convertClickTypeToListingType(clickType);
          }
          _context3.next = 16;
          return ensurePixallPageLoad(option, params, {
            history: history
          });
        case 16:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  }));
  return function sendImpression(_x8, _x9, _x10) {
    return _ref7.apply(this, arguments);
  };
}();
export default {
  sendPageEvent: sendPageEvent,
  sendClickEvent: sendClickEvent,
  sendImpression: sendImpression
};